module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921101151_T.d439a9a6.jpg";